import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import reportService, { BalanceReportDetail } from '../../services/reportService';
import styles from './ReportsPage.module.scss';
import { formatDateTime } from '../../utils/helpers';

const BalanceReportDetailPage: React.FC = () => {
  const { customerId } = useParams<{ customerId: string }>();
  const navigate = useNavigate();
  const [detail, setDetail] = useState<BalanceReportDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!customerId) return;
    setLoading(true);
    setError(null);
    reportService.getBalanceReportDetail(customerId)
      .then(data => setDetail(data))
      .catch(() => setError('Failed to load balance detail'))
      .finally(() => setLoading(false));
  }, [customerId]);

  return (
    <div className={styles.reportSection} style={{ maxWidth: 900, margin: '0 auto' }}>
      <button className={styles.filterBtn} style={{ marginBottom: 16 }} onClick={() => navigate(-1)}>
        ← Back
      </button>
      <h2>Balance Report Detail</h2>
      {loading ? (
        <div>Loading...</div>
      ) : error ? (
        <div className={styles.errorMsg}>{error}</div>
      ) : detail ? (
        <>
          <div style={{ marginBottom: 16 }}>
            <strong>Customer Name:</strong> {detail.customer.name}<br />
            <strong>Phone:</strong> {detail.customer.phone}
          </div>
          <div className={styles.tableWrapper}>
            <table className={styles.reportTable}>
              <thead>
                <tr>
                  <th>Date/Time</th>
                  <th>Type</th>
                  <th>Total Amount</th>
                  <th>Received Amount</th>
                  <th>Running Balance</th>
                </tr>
              </thead>
              <tbody>
                {detail.transactions.map((row, idx) => (
                  <tr key={idx}>
                    <td>{formatDateTime(row.date)}</td>
                    <td>{row.type === 'invoice' ? 'Invoice' : 'Received'}</td>
                    <td>{row.total_amount ? row.total_amount.toLocaleString() : '-'}</td>
                    <td>{row.received_amount ? row.received_amount.toLocaleString() : '-'}</td>
                    <td>{row.running_balance.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default BalanceReportDetailPage; 